import { configuration, Route } from "configuration"
import { UserModel } from "model/UserModel"

// Клиенты, которым нужен только маппинг (УПД и сметы): остальные пункты
// сайдбара у них видны, но заблокированы
const MAPPING_ONLY_TENANTS = ["Unistroy"]
const MAPPING_MODE = "CLASSIFIER"

// Пункт доступен, если у арендатора есть нужный режим (или режим не нужен).
// Клиентам "только маппинг" — только пункты маппинга
export const isRouteAllowed = (route: Route, user: UserModel): boolean => {
  const routeMode = route.mode?.toUpperCase()
  if (MAPPING_ONLY_TENANTS.includes(user.tenant.name) && routeMode !== MAPPING_MODE) {
    return false
  }
  const userModes = user.tenant.modes.map((mode) => mode.name.toUpperCase())
  return !routeMode || userModes.includes(routeMode)
}

export const isAdmin = (user: UserModel): boolean =>
  user.role?.name.toLowerCase() === "admin"

const sidebarRoutes = () =>
  configuration.sidebar.routes.flatMap((route) =>
    route.subRoutes ? route.subRoutes : [route],
  )

// Можно ли открыть страницу по адресу. Админам — любую. Остальным — только
// открытые в сайдбаре: не заблокированные для всех и доступные клиенту.
// Страниц вне сайдбара (url не передан) — только админам
export const canOpenPage = (url: string | undefined, user: UserModel): boolean => {
  if (isAdmin(user)) return true
  const route = url ? sidebarRoutes().find((route) => route.url === url) : undefined
  return !!route && !route.isDisabled && isRouteAllowed(route, user)
}

// Первая доступная страница из сайдбара — на неё уводим с корня и с
// несуществующих адресов
export const getHomeUrl = (user: UserModel): string | undefined => {
  const home = sidebarRoutes().find(
    (route) => !!route.url && !route.isDisabled && isRouteAllowed(route, user),
  )
  return home?.url
}
